export const CONTAINER_PROPS = {
    pt: '16px',
    pb: '16px',
    mdPt: '18px',
    mdPb: '18px',
};
export const DESTINATION_CONTAINER_PROPS = {
    pt: '7px',
    pb: '7px',
    lgPt: '12px',
    lgPb: '12px',
};
export const MAX_DROP_DOWN_ITEMS = 5;
export const SCROLL_VALUE_FOR_MENU_VISIBILITY = 100;
export const PAGE_LEVEL_NAVIGATION_DEFAULT_HEIGHT = {
    desktop: 76,
    tablet: 72,
    mobile: 68,
};
